import Vue from 'vue'
import Vuex from 'vuex'
import { getStorage } from '../utils/utils.js'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    renderData: {},
    toolBarLeft: window.innerWidth - 813,
    netDiskClicked: 0,
    computedWidth: window.innerWidth - 210,
    computedHeight: window.innerHeight - 63,
    user: {
      status: getStorage('user' || '[]') == null ? '未登录' : '',
      info: getStorage('user' || '[]') == null ? '' : getStorage('user' || '[]')
    },
    filesList: [],
    tagsList: [],
    currentTag: {},
    rootFile: {},
    currentDirGuid: '',
    contextMenuElement: null,
    contextMenuElementFile: null,
    isArrange: false,
    target: '',
    srcPage: null,
    customerInfo: null,
    currentFileList: [],
    banners: [],
    showProgress: false,
    uploadedFile: null,
    uploadRequestData: {},
    fileRouterList: [],
    netDiskSpaceUsed: null,
    externalNginxUrl: '',
    uploadCode: 0,
    cusDirFile: '',
    fileUploadingList: [],
    openFileUploadingDialog: false,
    hrefFlag: null,
    isCloudAdmin: false,
    isCommonFileAdmin: false,
    genechemFile: null
  },
  mutations: {
    setToolBarLeft (state, data) {
      state.toolBarLeft = data
    },
    setNetDiskClicked (state, data) {
      state.netDiskClicked = data
    },
    setComputedWidth (state, data) {
      state.computedWidth = data
    },
    setComputedHeight (state, data) {
      state.computedHeight = data
    },
    setFilesList (state, data) {
      state.filesList = data
    },
    setTagsList (state, data) {
      state.tagsList = data
    },
    setCurrentTag (state, data) {
      state.currentTag = data
    },
    setRootFile (state, data) {
      state.rootFile = data
    },
    setCurrentDirGuid (state, data) {
      state.currentDirGuid = data
    },
    setContextMenuElement (state, data) {
      state.contextMenuElement = data
    },
    setContextMenuElementFile (state, data) {
      state.contextMenuElementFile = data
    },
    setIsArrange (state, data) {
      state.isArrange = data
    },
    setTarget (state, data) {
      state.target = data
    },
    setSrcPage (state, data) {
      state.srcPage = data
    },
    setCustomerInfo (state, data) {
      state.customerInfo = data
    },
    setCurrentFileList (state, data) {
      state.currentFileList = data
    },
    setBanners (state, data) {
      state.banners = data
    },
    setShowProgress (state, data) {
      state.showProgress = data
    },
    setUploadedFile (state, data) {
      state.uploadedFile = data
    },
    setUploadRequestData (state, data) {
      state.uploadRequestData = data
    },
    setFileRouterList (state, data) {
      state.fileRouterList = data
    },
    setNetDiskSpaceUsed (state, data) {
      state.netDiskSpaceUsed = data
    },
    setExternalNginxUrl (state, data) {
      state.externalNginxUrl = data
    },
    setUploadCode (state, data) {
      state.uploadCode = data
    },
    setCusDirFile (state, data) {
      state.cusDirFile = data
    },
    setFileUploadingList (state, data) {
      state.fileUploadingList = data
    },
    setOpenFileUploadingDialog (state, data) {
      state.openFileUploadingDialog = data
    },
    setHrefFlag (state, data) {
      state.hrefFlag = data
    },
    setIsCloudAdmin (state, data) {
      state.isCloudAdmin = data
    },
    setIsCommonFileAdmin (state, data) {
      state.isCommonFileAdmin = data
    },
    initCustomerInfo (state, data) {
      state.customerInfo = data
    },
    setGenechemFile (state, data) {
      state.genechemFile = data
    }
  },
  getters: {
    getIsLogin: () => {
      return getStorage('user' || '[]') == null ? '未登录' : ''
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js